<template>
  <Layout class="layout_simple">
    <template v-slot:main>
      <div class="section">
        <Title>
          Ожидайте, ваш чек в процессе фискализации
        </Title>
      </div>
      <div class="section section_flex-center">
        <Loader/>
      </div>
    </template>
  </Layout>
</template>

<script>
import {VIEWS} from '@/views/names'

import Title from '@/app/components/Title'
import Loader from '@/app/components/Loader'
import Layout from '@/app/components/Layout'

const UPDATE_TIMEOUT = 10000

export default {
  name: VIEWS.load.name,
  components: {
    Title,
    Loader,
    Layout
  },
  data() {
    return {
      updateInterval: null
    }
  },
  methods: {
    setStatusReceipt() {
      clearInterval(this.updateInterval)
      this.$service.statusReceipt()
          .then(() => {
            this.updateInterval = setInterval(() => {
              this.setStatusReceipt()
            }, UPDATE_TIMEOUT)
          })
    }
  },
  mounted() {
    this.setStatusReceipt()
  },
  destroyed() {
    clearInterval(this.updateInterval)
  }
}
</script>
